import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Url from "app/shared/constants/Url";

const TRANSLATE_BATCH_URL = `${Url.nodeClientURL}/translate/batch`;

const STATIC_LABELS = {
  title: "Thank You for Participating!",
  subtitle: "Your response has been successfully submitted.",
  para1Before: "At",
  para1Mid: "every voice matters. Your participation during",
  para1After: "contributes to building a stronger, smarter, and safer workplace.",
  para2: "Safety is not just a compliance requirement — it is a shared responsibility and a culture we build together.",
  para3: "We appreciate your time and commitment toward proactive safety engagement.",
  tip1: "Continue being a Safety Champion",
  tip2: "Encourage others to participate",
  tip3: "Make safety a daily habit",
  exploreBtn: "Explore",
};

const BRAND_NAME = "CLIDE Analyser Safety Software";
const SAFETY_WEEK = "Safety Week (4th March – 11th March 2026)";
const BRAND_SHORT = "CLIDE Analyser";

export default function ThankYouSafetyPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const language = searchParams.get("lang") || "en";

  const [translationMap, setTranslationMap] = useState(null);

  const tr = (text) => {
    if (!text || language === "en" || !translationMap) return text;
    return translationMap.has(text) ? translationMap.get(text) : text;
  };

  useEffect(() => {
    if (language === "en") return;
    let cancelled = false;
    const strings = Object.values(STATIC_LABELS);

    axios
      .post(TRANSLATE_BATCH_URL, { texts: strings, to: language })
      .then((res) => {
        if (cancelled) return;
        const translations = res?.data?.translations;
        if (Array.isArray(translations) && translations.length === strings.length) {
          const map = new Map();
          strings.forEach((s, idx) => map.set(s, translations[idx] || s));
          setTranslationMap(map);
        }
      })
      .catch(() => {
      });

    return () => {
      cancelled = true;
    };
  }, [language]);

  const handleExplore = () => {
    window.location.href = "https://clideanalyser.com/engage";
  };

  useEffect(() => {
    document.body.style.background =
      "linear-gradient(135deg, #0f2027, #203a43, #2c5364)";
    return () => {
      document.body.style.background = "";
    };
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card
              className="border-0 shadow-lg text-center p-2 p-md-3"
              style={{
                borderRadius: "20px",
                backdropFilter: "blur(10px)",
                background: "rgba(255, 255, 255, 0.95)",
                animation: "fadeIn 0.8s ease-in-out",
              }}
            >
              <Card.Body>
                <div
                  className="mb-4 d-inline-flex align-items-center justify-content-center"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,rgb(243, 167, 126), rgb(255, 90, 31))",
                    fontSize: "45px",
                    color: "white",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                  }}
                >
                  👍🏻
                </div>

                <h1 className="fw-bold mb-3" style={{ fontSize: "2.5rem" }}>
                  {tr(STATIC_LABELS.title)}
                </h1>

                <p className="lead text-secondary">
                  {tr(STATIC_LABELS.subtitle)}
                </p>

                <hr className="my-4" />

                <p className="text-muted">
                  {tr(STATIC_LABELS.para1Before)} <strong>{BRAND_NAME}</strong>,{" "}
                  {tr(STATIC_LABELS.para1Mid)} <strong>{SAFETY_WEEK}</strong>{" "}
                  {tr(STATIC_LABELS.para1After)}
                </p>

                <p className="text-muted">
                  {tr(STATIC_LABELS.para2)}
                </p>

                <p className="text-muted">
                  {tr(STATIC_LABELS.para3)}
                </p>

                <div className="mt-4 text-start text-md-center fw-medium">
                  <p className="mb-2">🔹 {tr(STATIC_LABELS.tip1)}</p>
                  <p className="mb-2">🔹 {tr(STATIC_LABELS.tip2)}</p>
                  <p className="mb-2">🔹 {tr(STATIC_LABELS.tip3)}</p>
                </div>

                <div className="mt-5">
                  <Button
                    size="lg"
                    onClick={handleExplore}
                    style={{
                      padding: "12px 35px",
                      borderRadius: "50px",
                      fontWeight: "600",
                      fontSize: "1.1rem",
                      background: "linear-gradient(135deg,rgb(239, 151, 103), rgb(255, 90, 31))",
                      border: "none",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.transform = "scale(1)")
                    }
                  >
                    {tr(STATIC_LABELS.exploreBtn)} {BRAND_SHORT}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
